import { mockAnalytics } from './segment';

export default class SegmentAnalytics {

  /**
   * Opt-out only. Fires when EITHER:
   *  - the browser sends GPC (navigator.globalPrivacyControl === true) and the
   *    visitor is US (CCPA scope), OR
   *  - the B2C id token carries a persisted `gpc_compliant: true` claim (any region).
   * Then: fire the Segment event, turn OneTrust consent off, and swap Segment for
   * the no-op mock so nothing further is sent. Call AFTER identify so the event
   * binds to the user.
   */
  static handleGpcSignal(jwtGpcCompliant = false): void {
    if (typeof window === 'undefined') {
      return;
    }

    const browserGpc =
      (navigator as Navigator & { globalPrivacyControl?: boolean })
        .globalPrivacyControl === true;
    const userCountry = window.OneTrust?.getGeolocationData()?.country;
    const isUS = !!userCountry && userCountry.toLowerCase() === 'us';

    if (!((browserGpc && isUS) || jwtGpcCompliant === true)) {
      return;
    }

    // 1) Record the opt-out signal (on the live instance, before the swap).
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics?.track) {
      segmentAnalytics.track('GPC Signal Detected', {
        globalPrivacyControl: true,
      });
    }

    // 2) Turn consent off on this device.
    (window.OneTrust as any)?.RejectAll?.();

    // 3) Stop sending any further data to Segment.
    (window as any).segmentAnalytics = mockAnalytics;
    (window as any).analytics = mockAnalytics;
  }

  static customEvent(action: string) {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track) {
      segmentAnalytics.track(action);
    }
  }

  static loggedIn(uniqueId: string, userEmail: string) {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track && segmentAnalytics.identify) {
      segmentAnalytics.identify(uniqueId, {
        email: userEmail,
      });

      segmentAnalytics.track('Logged In');
    }
  }

  static findARetailer(url: String) {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track) {
      segmentAnalytics.track('Find a Retailer');
    }
  }

  static printRecommendations() {
    const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.track) {
      segmentAnalytics.track('Print Recommendations');
    }
  }

  static innerSectionVisit(category: string, name: string) {
    /* Via Segment Docs:
    /   category: The category of the page. Useful for things like ecommerce where many pages often live under a larger category.
    /   name: The name of the page, for example Signup or Home.
    */
   (window as any).currentPageName = category;
   const segmentAnalytics = (window as any).segmentAnalytics;
    if (segmentAnalytics && segmentAnalytics.page) {
      segmentAnalytics.page(category, name);
    }
  }
}
